import { IconProp, library } from "@fortawesome/fontawesome-svg-core";
import {
  faAnchor,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faAngleLeft,
  faAngleRight,
  faArrowDown,
  faArrowRight,
  faArrowUp,
  faBars,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCog,
  faCopy,
  faEdit,
  faExclamationTriangle,
  faExternalLinkSquareAlt,
  faEye,
  faEyeSlash,
  faFileUpload,
  faFolder,
  faFolderOpen,
  faGuitar,
  faLock,
  faPlus,
  faSave,
  faSearch,
  faTimes,
  faTimesCircle,
  faTrash,
  faTrashAlt,
  faWindowClose,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MouseEventHandler } from "react";

library.add(faFolderOpen);
library.add(faFileUpload);
library.add(faFolder);
library.add(faGuitar);
library.add(faTrash);
library.add(faTrashAlt);
library.add(faAnchor);
library.add(faArrowUp);
library.add(faArrowDown);
library.add(faArrowRight);
library.add(faAngleLeft);
library.add(faAngleRight);
library.add(faAngleDoubleLeft);
library.add(faAngleDoubleRight);
library.add(faExternalLinkSquareAlt);
library.add(faEdit);
library.add(faSave);
library.add(faCheck);
library.add(faEye);
library.add(faEyeSlash);
library.add(faWindowClose);
library.add(faPlus);
library.add(faSearch);
library.add(faChevronUp);
library.add(faChevronLeft);
library.add(faChevronRight);
library.add(faChevronDown);
library.add(faCog);
library.add(faCheckCircle);
library.add(faTimesCircle);
library.add(faTimes);
library.add(faLock);
library.add(faSearch);
library.add(faExclamationTriangle);
library.add(faBars);
library.add(faCopy);

type Icon = {
  icon: IconProp;
  altText: string; // required, because accessability is good
  className?: string;
  color?: string;
  hiddenIcon?: boolean;
  onClick?: MouseEventHandler<SVGSVGElement>;
  onMouseEnter?: MouseEventHandler<SVGSVGElement>;
  onMouseLeave?: MouseEventHandler<SVGSVGElement>;
};

const Icon = ({
  ref,
  ...props
}: Icon & {
  ref?: React.Ref<SVGSVGElement>;
}) => {
  return (
    <FontAwesomeIcon
      ref={ref}
      onMouseEnter={props.onMouseEnter}
      onMouseLeave={props.onMouseLeave}
      title={props.altText}
      onClick={props.onClick}
      color={props.color}
      icon={props.icon}
      className={"icon " + (props.className ?? "")}
      style={props.hiddenIcon ? { visibility: "hidden" } : {}}
    />
  );
};

export default Icon;

// export a second time to be lazy
export { Icon };
